import { Stack } from "@mui/material";
import {
  ChipV2 as Chip,
  Text,
  TooltipInfoIcon,
} from "@asayinc/component-library";
import { CardWrapper } from "../../../../../../../components/Common";
import NetworkTrendGraph from "../NetworkTrendGraph";
import { useNetworkGraphData } from "./useNetworkGraphData";
import { NetworkTrendsPeriod } from "../../../../../../../store/allNetworkStats/types";

const NetworkTrendGraphCard = () => {
  const {
    graphData,
    shareholderMax,
    sharesMax,
    timeframe,
    setTimeframe,
    isLoading,
  } = useNetworkGraphData();

  const handlePeriodChange = (period: NetworkTrendsPeriod) => {
    setTimeframe(period);
  };

  return (
    <CardWrapper
      cardName="network-trend-graph"
      sx={{ width: "100%", minWidth: 720, mb: 12 }}
    >
      <Stack data-testid={isLoading ? "graph-loading" : "graph-loaded"}>
        <Stack direction="row" mb={2}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Text variant="subtitle2" loadingProps={{ sx: { width: 100 } }}>
              {isLoading ? undefined : "Network trends"}
            </Text>
            <TooltipInfoIcon
              title="Tracks network growth over the selected time period"
              iconColor="black"
            />
          </Stack>
          <Stack direction="row" ml="auto" gap={2.5}>
            <Chip
              data-testid="1m-chip"
              onClick={() => handlePeriodChange("1m")}
              label="1 month"
              size="small"
              selected={timeframe === "1m"}
            />
            <Chip
              data-testid="3m-chip"
              onClick={() => handlePeriodChange("3m")}
              label="3 months"
              size="small"
              selected={timeframe === "3m"}
            />
            <Chip
              data-testid="6m-chip"
              onClick={() => handlePeriodChange("6m")}
              label="6 months"
              size="small"
              selected={timeframe === "6m"}
            />
            <Chip
              data-testid="1y-chip"
              onClick={() => handlePeriodChange("1y")}
              label="1 year"
              size="small"
              selected={timeframe === "1y"}
            />
          </Stack>
        </Stack>
        <NetworkTrendGraph
          graphData={graphData}
          shareholderMax={shareholderMax}
          sharesMax={sharesMax}
          isLoading={isLoading}
        />
      </Stack>
    </CardWrapper>
  );
};

export default NetworkTrendGraphCard;
